import { MayNull, useAccountContext, useDate } from '@apeiron/temp'
import { useWalletAddress } from '@apeiron/wallet'
import { useNowContext } from '@src/contexts/share/NowContext'
import { OrbitalTrackLite } from '@src/types/orbitalTrack'
import * as R from 'ramda'
import { useCallback } from 'react'

const useOrbitalTrackHelper = (): Hook => {
  const { isAfterNow } = useNowContext()

  const { account } = useAccountContext()

  const { compareAddress } = useWalletAddress()

  const { dateValid } = useDate()

  const checkInCooldown = useCallback(
    (track: MayNull<OrbitalTrackLite>): boolean => {
      if (R.isNil(track) || !dateValid(track.availableTrackTime)) {
        return false
      }

      const canAttachAt = new Date(track.availableTrackTime)

      return isAfterNow(canAttachAt)
    },
    [isAfterNow, dateValid]
  )

  const checkIsStarOwner = useCallback(
    (track: MayNull<OrbitalTrackLite>) => {
      return compareAddress(
        account.walletAddress,
        R.pathOr('', ['star', 'owner', 'walletAddress'], track)
      )
    },
    [account.walletAddress, compareAddress]
  )

  const checkIsPlanetOwner = useCallback(
    (track: MayNull<OrbitalTrackLite>) => {
      return compareAddress(
        account.walletAddress,
        R.pathOr('', ['planet', 'owner', 'walletAddress'], track)
      )
    },
    [account.walletAddress, compareAddress]
  )

  return { checkInCooldown, checkIsStarOwner, checkIsPlanetOwner }
}

type Hook = {
  checkInCooldown: (track: MayNull<OrbitalTrackLite>) => boolean
  checkIsStarOwner: (track: MayNull<OrbitalTrackLite>) => boolean
  checkIsPlanetOwner: (track: MayNull<OrbitalTrackLite>) => boolean
}

export default useOrbitalTrackHelper
